const popularArmrests = ['arms_N']
// const armrests = ['arms_N', 'arms_C', 'arms_I', 'arms_B', 'arms_D', 'arms_J', 'arms_F', 'arms_L'].map(
const armrests = ['arms_N', 'arms_C', 'arms_I', 'arms_B', 'arms_D', 'arms_J'].map(
// const armrests = ['arms_N'].map(
  (node, key) => ({
    node,
    mostPopular: popularArmrests.includes(node),
    buttonImage: require(`../img/${node}.png`),
    buttonName: node.split('_')[1],
    containsWood: [ 'arms_D', 'arms_F', 'arms_J', 'arms_S'].includes(node),
    price: ['arms_B', 'arms_D'].includes(node)?400:['arms_J', 'arms_F', 'arms_L'].includes(node)?1400:node == 'arms_S' ? 1800: 0,
  })
)

export default armrests
